<template>
    <div class="popup-container" v-on:click.self="closePopup">
        <div class="popup">
            <button class="popup__close" v-on:click="closePopup">Close</button>
            <div class="right-content">
                <img src="assets/images/popup_bg.png" alt="Popup Background" />
            </div>
            <div class="left-content">
                <img src="assets/images/logo_colored.svg" alt="PlanIt Logo" />

                <p>Sign up to keep track of your trips</p>

                <div class="facebook-continue">
                    <!-- For Visual Purposes only, should be replaced with proper facebook plugin during production: https://developers.facebook.com/docs/facebook-login/web/login-button/ -->
                    <button class="temp-facebook-btn">
                        <i class="facebook-icon"></i>Continue with Facebook
                    </button>
                </div>

                <div class="or-border">or</div>

                <form>
                    <input type="text" placeholder="User Name" />
                    <input type="password" placeholder="Password" />

                    <button type="submit" class="main-btn" v-on:click="loginUser">Log In</button>

                    <p>New to PlanIt? <a href="">Sign Up</a></p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'LoginPopup',
        methods: {
            closePopup: function() {
                Eventbus.$emit('closeLoginPopup')
            },
            loginUser: function() {
                Eventbus.$emit('loginUser')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/accountPopup";
</style>

